export default __webpack_public_path__ + "static/media/krom_logo.46bffd5a.png";